<div class="contenitore">
    <h1>Corso di Crittografia a Roma</h1>
    <p>
        Organizzato congiuntamente dal Laboratorio di Crittografia dell'Università di Roma Tre e dall'Associazione
        Nazionale di Crittografia "De Componendis Cifris", nella settimana <strong>19 – 23 maggio 2025</strong>.
    </p>
    <p>
        Il Workshop è dedicato allo studio dei sistemi di cifratura e delle loro proprietà. In particolare, verranno
        analizzati metodi e algoritmi sviluppati per verificare il livello di sicurezza dei crittosistemi, sia dal punto
        di vista formale (nell'ambito dei protocolli) sia dal punto di vista della crittoanalisi.
    </p>
    <p>
        Il Workshop si terrà presso il Laboratorio e sarà arricchito da esempi, esercitazioni pratiche e lezioni online
        messe a disposizione dall'Associazione.
    </p>
    <p>
        <strong>Contatti:</strong><br>
        <em>Studenti/Dottorandi di Roma Tre: </em> <a
            href="mailto:marco.pedicini&#64;uniroma3.it">marco.pedicini&#64;uniroma3.it</a><br>
        <em>Altri partecipanti: </em> <a href="mailto:formazione&#64;decifris.it">formazione&#64;decifris.it</a>
    </p>
    <p>
        Le richieste di iscrizione devono pervenire entro il <strong>21 marzo 2025</strong>. La frequenza permetterà il
        rilascio di un attestato di partecipazione.
    </p>
    <div class="link">
        Vedi la locandina ufficiale:
        <a href="https://drive.google.com/file/u/1/d/15-197mhFz2Yi9Fb4u83h5qieSlKzCPDg/edit" target="_blank"> qui
            il PDF</a>
    </div>
</div>